import {
    TYPE_LINEUP,
    TYPE_CUSTOMHTML,
    TYPE_SPONSORED,
    TYPE_ADELEMENT,
    TYPE_NEWSLETTER,
    TYPE_CONTESTPROMO,
    TYPE_MYLOCAL,
    TYPE_SHORTS,
    TYPE_MUSTWATCH,
    TYPE_CTA,
    TYPE_RECOMMENDED_VIDEO,
    TYPE_MY_OLYMPICS,
    TYPE_SCHEDULE,
    TYPE_RADIOBAR,
    TYPE_TRENDING,
    TYPE_BROADCAST_SCHEDULE,
    TYPE_CONTENT_QUERY_WIDGET,
    TYPE_MLDRIVEN_ITEMS,
    TYPE_CONTENT_PACKAGE,
} from "../../../../constants/page";

import Card from "../../../../components/Card/component";
import ContentQueryWidget from "../ContentQueryWidget/component";
import SponsoredWidgetContainer from "../SponsorInfoContainer/component";
import VideoRecommendations from "../../../../components/VideoRecommendations/component";
import LineupContainer from "../LineupContainer/component";
import CTAWidgetContainer from "../CTAWidgetContainer/component";
import CustomHtmlContainer from "../CustomHtmlContainer/component";
import NewsletterContainer from "../NewsletterContainer/component";
import AdElementContainer from "../AdElementContainer/component";
import { MyLocalContainer } from "../MyLocalContainer/component";
import ShortsWidget from "../../../../components/ShortsWidget";
import PlaylistWidget from "../../../../components/PlaylistWidget";
import TrendingContainer from "../TrendingContainer/component";
import MLDrivenItemsWidget from "../MLDrivenItemsContainer/component";
import ContestPromoContainer from "../ContestPromoContainer/component";
import MyOlympicsContainer from "../MyOlympicsContainer/component";
import ScheduleContainer from "../ScheduleContainer/component";
import { BroadcastScheduleContainer } from "../BroadcastScheduleContainer/component";
import RadioBarContainer from "../RadioBarContainer/component";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";

const PageContent = (props) => {
    switch (props?.type) {
        case TYPE_LINEUP:
            return <LineupContainer {...props} />;
        case TYPE_SPONSORED:
            return <SponsoredWidgetContainer {...props} />;
        case TYPE_CUSTOMHTML:
            return <CustomHtmlContainer {...props} />;
        case TYPE_ADELEMENT:
            return (
                <AdElementContainer
                    params={props?.params}
                    sectionIndex={props?.sectionIndex}
                    viewport={props?.viewport}
                />
            );
        case TYPE_NEWSLETTER:
            return <NewsletterContainer {...props} />;
        case TYPE_CONTESTPROMO:
            return <ContestPromoContainer {...props} />;
        case TYPE_MYLOCAL:
            return (
                <MyLocalContainer
                    params={props?.params}
                    position={props?.position}
                />
            );
        case TYPE_SHORTS:
            return (
                <ShortsWidget
                    title={props.params?.title}
                    navigation={props.params?.shorts.options}
                    {...props}
                />
            );
        case TYPE_MUSTWATCH:
            return (
                <PlaylistWidget
                    title={props.params?.title}
                    lineupSlug={props.params?.lineupSlug}
                />
            );
        case TYPE_CTA:
            return <CTAWidgetContainer {...props} />;
        case TYPE_RECOMMENDED_VIDEO:
            return <VideoRecommendations {...props} />;
        case TYPE_MY_OLYMPICS:
            return <MyOlympicsContainer {...props} />;
        case TYPE_SCHEDULE:
            return <ScheduleContainer {...props} />;
        case TYPE_RADIOBAR:
            return <RadioBarContainer {...props} />;
        case TYPE_TRENDING:
            return <TrendingContainer {...props} />;
        case TYPE_BROADCAST_SCHEDULE:
            return <BroadcastScheduleContainer {...props} />;
        case TYPE_CONTENT_QUERY_WIDGET:
            return <ContentQueryWidget {...props} />;
        case TYPE_MLDRIVEN_ITEMS:
            return <MLDrivenItemsWidget {...props} />;
        case TYPE_CONTENT_PACKAGE:
            return <Card {...props?.params} />;
        default:
            return null;
    }
};

PageContent.TYPE_LIST = [
    TYPE_LINEUP,
    TYPE_SPONSORED,
    TYPE_CUSTOMHTML,
    TYPE_ADELEMENT,
    TYPE_NEWSLETTER,
    TYPE_CONTESTPROMO,
    TYPE_MYLOCAL,
    TYPE_SHORTS,
    TYPE_MUSTWATCH,
    TYPE_CTA,
    TYPE_RECOMMENDED_VIDEO,
    TYPE_MY_OLYMPICS,
    TYPE_SCHEDULE,
    TYPE_RADIOBAR,
    TYPE_TRENDING,
    TYPE_BROADCAST_SCHEDULE,
    TYPE_CONTENT_QUERY_WIDGET,
    TYPE_MLDRIVEN_ITEMS,
    TYPE_CONTENT_PACKAGE,
];

const SafePageContent = withSuspensefulErrorBoundary(PageContent);

export { PageContent };
export default SafePageContent;
